import { InjectionToken } from '@angular/core';

import type { OrderInvoiceBlockScenarioContent } from '@front-platform/content-builder';
import { DoodOrderPaymentModel } from '@store/order/order.model';

/** Runtime VM emitted by `OrderInvoiceBlock` data sources. */
export type OrderInvoiceBlockViewModel = {
  payments: readonly DoodOrderPaymentModel[];
};

/** Scenario transport matches the runtime VM shape (payments cast at the preview boundary). */
export type OrderInvoiceBlockScenarioViewModel = OrderInvoiceBlockScenarioContent;

export const ORDER_INVOICE_BLOCK_EMPTY_VM: OrderInvoiceBlockViewModel = {
  payments: [],
};

export interface OrderInvoiceBlockDataSource {
  readonly vm$: import('rxjs').Observable<OrderInvoiceBlockViewModel>;
}

export const ORDER_INVOICE_BLOCK_DATA_SOURCE = new InjectionToken<OrderInvoiceBlockDataSource>(
  'ORDER_INVOICE_BLOCK_DATA_SOURCE',
);
